module.exports = __webpack_public_path__ + "static/media/L2.7c417a1e.svg";